import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Eyebrow, Reveal } from "./ui";

const VALUES = [
  ["Përzgjedhja", "Zgjedhim pllakat një nga një, duke parë damarët para çmimit."],
  ["Saktësia", "Prerje në milimetër, bashkime me motiv pasqyrë, fuga të padukshme."],
  ["Dora", "Buzë, lavamanë dhe detaje të përfunduara me dorë, si gjithmonë."],
];

export const Bottega = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const imgY = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);
  const smallY = useTransform(scrollYProgress, [0, 1], [60, -60]);

  return (
    <section id="bottega" ref={ref} className="relative bg-[#EFEAE0] text-[#1B1A17] py-24 sm:py-36 overflow-hidden" data-testid="about-section">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-14 lg:gap-10 items-center">
        <div className="lg:col-span-6 relative">
          <div className="relative aspect-[4/5] overflow-hidden" style={{ clipPath: "polygon(0 0, 88% 0, 100% 12%, 100% 100%, 0 100%)" }}>
            <motion.img style={{ y: imgY }} src="/img/scalpello.jpg" alt="Mjeshtër që punon mermerin me daltë" className="absolute inset-0 w-full h-[116%] -top-[8%] object-cover" />
          </div>
          <motion.div style={{ y: smallY }} className="absolute -bottom-10 right-0 sm:-right-6 w-[46%] aspect-square overflow-hidden border-[10px] border-[#EFEAE0]">
            <img src="/img/cava.jpg" alt="Gurore mermeri" className="w-full h-full object-cover" />
          </motion.div>
        </div>
        <div className="lg:col-span-6 lg:pl-10">
          <Reveal>
            <Eyebrow light>Punëtoria</Eyebrow>
            <h2 className="font-display font-light text-5xl sm:text-6xl lg:text-7xl mt-6 leading-[1]">
              Vëllezërit Peci, <em className="text-[#8A6A2E]">mjeshtrit</em> e gurit.
            </h2>
            <p className="mt-8 text-[#3F3B34] text-base md:text-lg leading-relaxed max-w-xl">
              Jemi një punëtori familjare: shesim pllaka mermeri dhe graniti dhe i përpunojmë në punëtorinë tonë, duke ndjekur çdo projekt personalisht. Besojmë se një gur natyror duhet zgjedhur, kuptuar dhe punuar me respekt.
            </p>
          </Reveal>
          <div className="mt-12 grid sm:grid-cols-3 gap-8">
            {VALUES.map(([t, d], i) => (
              <Reveal key={t} delay={0.1 + i * 0.1}>
                <div className="border-t border-[#1B1A17]/25 pt-5" data-testid={`about-value-${i}`}>
                  <h3 className="font-display text-2xl">{t}</h3>
                  <p className="mt-2 text-sm text-[#4A453D] leading-relaxed">{d}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
